var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M16.8006 13.5188L10.7886 3.10508C10.5231 2.64458 10.0311 2.36108 9.50011 2.36108C8.96911 2.36108 8.47711 2.64458 8.21161 3.10508L2.19961 13.5188C1.93411 13.9793 1.93411 14.5456 2.19961 15.0068C2.46511 15.4666 2.95636 15.7501 3.48811 15.7501H15.5129C16.0439 15.7501 16.5359 15.4666 16.8014 15.0061C17.0669 14.5456 17.0669 13.9793 16.8006 13.5188Z",
    fill: "#FF5E5E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3842 13.3095C10.3842 13.5742 10.2305 14.25 9.49547 14.25C8.76047 14.25 8.61572 13.5735 8.61572 13.3095C8.61572 13.0507 8.77922 12.3577 9.49547 12.3577C10.2117 12.3577 10.3842 13.0507 10.3842 13.3095ZM8.68922 10.4392V7.17598C8.68922 6.72823 9.05222 6.36523 9.49997 6.36523C9.94772 6.36523 10.3107 6.72823 10.3107 7.17598V10.44C10.3107 10.887 9.94772 11.25 9.49997 11.25C9.05222 11.25 8.68922 10.887 8.68922 10.4392Z",
    fill: "#FF3D3D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.0427240c7acd555a5a7bfeee8616a48a.svg";
export { ForwardRef as ReactComponent };